import React from "react";
import "./RideHireFeatures.css"; // Import the CSS file
import { FaCar, FaDollarSign, FaFilter, FaShieldAlt } from "react-icons/fa"; // Icons

const features = [
  {
    icon: <FaCar size={30} />,
    title: "Global Vehicle Search",
    description: "Sed ut perspiciatis unde omnis natus error sit voluptatem.",
  },
  {
    icon: <FaDollarSign size={30} />,
    title: "Find The Best Price",
    description: "Sed ut perspiciatis unde omnis natus error sit voluptatem.",
  },
  {
    icon: <FaFilter size={30} />,
    title: "Filter Exactly What You Want",
    description: "Sed ut perspiciatis unde omnis natus error sit voluptatem.",
  },
  {
    icon: <FaShieldAlt size={30} />,
    title: "Backed by RideHire's Guarantee",
    description: "Sed ut perspiciatis unde omnis natus error sit voluptatem.",
  },
];

const RideHireFeatures = () => {
  return (
    <div className="features-container">
      {/* Title & Subtitle */}
      <div className="features-header">
        <h2 className="features-title">How RideHire helps you for a better Travel</h2>
        <p className="features-subtitle">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
      </div>

      {/* Features Grid */}
      <div className="features-grid">
        {features.map((feature, index) => (
          <div key={index} className="feature-card">
            <div className="feature-icon">{feature.icon}</div>
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-description">{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RideHireFeatures;
